import { render, staticRenderFns } from "./detail1.vue?vue&type=template&id=f30c64d6&scoped=true&"
import script from "./detail1.vue?vue&type=script&lang=js&"
export * from "./detail1.vue?vue&type=script&lang=js&"
import style0 from "./detail1.vue?vue&type=style&index=0&id=f30c64d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_r7gorhlsuse2clbgb7n6qowp3u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30c64d6",
  null
  
)

export default component.exports